import mqtt from "mqtt"
import { useMsgStore } from "@/shore"
import { alertController, IonItem, loadingController, modalController } from "@ionic/vue"
import ajax from "./http"
import myAjax from "axios"
import store from "@/js/store"
import pagesQueue from "@/js/pagesQueue"
import { openMsgToast } from "./message"
import router from "@/router"
import PageDialog from "@/components/PageDialog.vue"
import { isReactive } from "vue"

let httpSend: any = false
let IsReceive: any = false
let httpCount: any = 0
let TeacherCount: any = 0
let connected: any = false
let IsStartClass = false

// 添加权限变化监听器
const permissionListeners: Array<() => void> = []
const msgArr: any = [] // 用户端收到的消息数组
let previousTimestamp = "0" // 陪练发送消息时的时间戳
let adminMsgArr: any = [] // 巡查官MQTT收到的消息
let adminTaskStatus: any = false // 是否开始执行轮训任务
let historyArrAdmin: any = [] // 巡查官收到的历史消息
// 从本地缓存中获取当前用户信息
let userinfo = JSON.parse(localStorage.getItem("userinfo") as string) || {}
const roomConfig = sessionStorage.getItem("roomConfig") || ""
const USER_TOPIC_URL = "11/student/operation_message/"
// 陪练定义mqtt实例
let teacherParams: any = {}

// 定义mqtt连接配置
const connection = {
  protocol: "wss",
  host: process.env.VUE_APP_MQTT_ADDRESS,
  port: process.env.VUE_APP_MQTT_ADDRESS_PORT,
  keepalive: 60,
  protocolVersion: 5 as any,
  properties: {
    sessionExpiryInterval: 7200, // 仅在 MQTT v5 时生效
  },
  endpoint: "/mqtt",
  clean: false,
  connectTimeout: 30 * 1000,
  reconnectPeriod: 3 * 1000, //1秒后重连
  clientId: `11_${userinfo.userId}${new Date().getTime()}`,
  username: "edu_video",
  password: "edu_video_2025",
}
// 定义mqtt实例
let client: any = null
let msgList = [] as any //历史数组
// 巡查官创建连接
function createConnectionAdmin() {
  localStorage.removeItem("pageList")
  localStorage.removeItem("componentOptions")
  return new Promise((resolve, reject) => {
    try {
      const { protocol, host, port, endpoint, ...options } = connection
      const connectUrl = `${protocol}://${host}:${port}${endpoint}`
      const newOptions = Object.assign({}, options, {
        clientId: `10_${userinfo.userId}_admin_${new Date().getTime()}`,
      })
      // 关闭已存在的连接
      if (client && client.connected) {
        client.end(true)
        client = null
      }
      client = mqtt.connect(connectUrl, newOptions)
      client.on("connect", async (packet: any) => {
        // 巡查官订阅陪练的topic（只在首次连接时订阅）
        const roomConfig = JSON.parse(sessionStorage.getItem("roomConfig") ?? "")
        if (!roomConfig.roomId) return false
        const isRequestHistory = sessionStorage.getItem("isRequestHistory")
        // MQTT返回的报文中，判断sessionPresent字段，true为已订阅false为未订阅
        if (!packet.sessionPresent) {
          SubscribeStudent(USER_TOPIC_URL)
        }
        if (!isRequestHistory) {
          //先订阅
          const res: any = await getRoomOperationList(roomConfig.roomId)
          sessionStorage.setItem("isRequestHistory", "true")
          msgList = [...res] //获取接口历史数据
          //这里的第一次newArry mqtt数据 这个是为空的
          const pageName: any = JSON.parse(localStorage.getItem("pageList") ?? "[]")
          let pageListName = ""
          if (pageName.length > 0) {
            pageListName = pageName[pageName.length - 1].page // 使用的最后一个组件
            msgList.map((key: any, i: number) => {
              if (key.command.module == pageListName) {
                historyArrAdmin.push(key)
              }
            })
            localStorage.setItem("historyArrAdmin", JSON.stringify(historyArrAdmin))
          }
          const pageList: Array<any> = JSON.parse(localStorage.getItem("pageList") || "[]")
          if (pageList?.length) {
            await pagesQueue.queuePageRun() // 还原页面
          } else {
            console.error("1.1----pageList is null")
          }
          // 截断-需要重新优化编写后续代码-优化点：处理订阅后收到的消息与历史数据存在时间差,需要比对两个数据源
        }
        if (!adminTaskStatus) {
          adminTaskStatus = true
          console.log("运行巡查官轮训任务")

          runAdminTask()
        }
      })
      client.on("message", async (topic: any, msg: any) => {
        // 巡查官接收到陪练端传回来的消息
        userinfo = JSON.parse(localStorage.getItem("userinfo") as string) || {}
        if (userinfo.userType === 1) {
          const decoder = new TextDecoder("utf-8")
          const decodedMessage = decoder.decode(msg)
          if (decodedMessage.indexOf("/av/") < 0) {
            const message = JSON.parse(decodedMessage)
            const newMessageData = {
              command: JSON.parse(JSON.parse(message.command)),
            }
            adminMsgArr.push(newMessageData)
            resolve(true)
          } else {
            resolve(false)
          }
        }
      })
    } catch (error) {
      console.log(error, "1.1----巡查官连接失败")
      reject(new Error())
    }
  })
}

async function runAdminTask(): Promise<void> {
  while (true) {
    // 使用循环替代递归
    try {
      await processNextItem()
      await delay(300) // 执行间隔
    } catch (error) {
      console.error("任务执行出错:", error)
      await delay(300) // 出错重试间隔
    }
    // 可以在这里添加停止条件，比如检查连接状态
    // if (!client || !client.connected) {
    //   break
    // }
  }
}

async function processNextItem(): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    setTimeout(async () => {
      try {
        let item
        if (adminMsgArr.length === 0 && historyArrAdmin.length > 0) {
          // item = historyArrAdmin.shift() // 直接移除
          item = historyArrAdmin.pop() // 直接移除
          historyArrAdmin = []
        } else if (adminMsgArr.length > 0 && historyArrAdmin.length > 0) {
          // 合并、去重、排序
          const merged = [...historyArrAdmin, ...adminMsgArr]
          const uniqueMap = new Map()
          for (const msg of merged) {
            const key = msg.command.timestamp // 或用 msg.command.timestamp
            if (!uniqueMap.has(key)) {
              uniqueMap.set(key, msg)
            }
          }
          const uniqueSorted = Array.from(uniqueMap.values()).sort(
            (a, b) => a.command.timestamp - b.command.timestamp
          )

          // item = uniqueSorted.shift()
          item = uniqueSorted.pop()

          // 从原数组移除该 item
          // if (historyArrAdmin.includes(item)) {
          //   historyArrAdmin.splice(historyArrAdmin.indexOf(item), 1)
          // } else if (adminMsgArr.includes(item)) {
          //   adminMsgArr.splice(adminMsgArr.indexOf(item), 1)
          // }
          historyArrAdmin = []
          adminMsgArr = []
        } else if (adminMsgArr.length > 0 && historyArrAdmin.length === 0) {
          item = adminMsgArr.shift() // 直接移除
        }

        if (item) {
          if (item.command.module === "App" && item.command.fn === "updateRoomStatus") {
            alert("课程已结束")
            return resolve()
          }
          await processMessage(item)
        }
        resolve()
      } catch (error) {
        reject(new Error())
      }
    }, 300)
  })
}

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

function findLastIndexes(arr: any) {
  return arr.reduce((acc: any, current: any, index: any) => {
    acc[current.name] = index // 总是更新为最后一次出现的索引
    return acc
  }, {})
}

function changeUserStatus(message: any) {
  try {
    const ind = msgArr.findIndex((item: any) => item.id == message.msgId)
    if (ind !== -1) {
      msgArr[ind].lock = false
    } else {
      console.warn(`Message with id ${message.msgId} not found`)
    }
  } catch (error) {
    console.error("Failed to change user status:", error)
  }
}

function cancelAppAlert() {
  alertController.dismiss()
}

function cancelModalAlert() {
  alertController.dismiss()
}

// 用户Student端创建连接
function createConnectionStudent() {
  try {
    const { protocol, host, port, endpoint, ...options } = connection
    const connectUrl = `${protocol}://${host}:${port}${endpoint}`
    // 关闭已存在的连接
    if (client && client.connected) {
      client.end(true)
    }
    client = mqtt.connect(connectUrl, options)
    client.on("connect", (packet: any) => {
      if (!connected) {
        console.log("Student----连接成功-------------", "********************************")
        pagesQueue.newQueuePageClear()
        runTask()
        if (userinfo.userType === 1) {
          IsReceive = true
        }
        if (userinfo.userType === 2) {
          httpSend = true
        }
      }
      console.log("Student--连接成功", connected)
      // MQTT返回的报文中，判断sessionPresent字段，true为已订阅false为未订阅
      if (!packet.sessionPresent) {
        SubscribeStudent(USER_TOPIC_URL)
        console.log("Student--订阅")
      }
      connected = true
      // const roomConfig = sessionStorage.getItem("roomConfig")
      // if (roomConfig != null) {
      //   setMqttStatus(JSON.parse(roomConfig).roomId)
      // }
    })
    client.on("online", () => {
      console.log("Student----online--------------")
      // 在这里处理重连后的逻辑
    })
    client.on("offline", () => {
      console.log("Student----Reconnecting to MQTT broker")
    })

    client.on("reconnect", function () {
      console.log("Student----正在重连..........", "********************************")
    })
    client.on("error", (error: any) => {
      console.log("Student----mqtt发生错误..........")
    })
    client.on("message", async (topic: any, msg: any) => {
      const decoder = new TextDecoder("utf-8")
      const decodedMessage = decoder.decode(msg)
      const message = JSON.parse(decodedMessage)
      const messageData = JSON.parse(message.command)
      console.log("Student----用户收到")
      const operationObj = JSON.parse(messageData)
      // 用户端接收到陪练端传回来的消息
      if (IsReceive) {
        console.log(operationObj, "message-1-1")
        if (operationObj.module === "App" && operationObj.fn === "updateRoomStatus") {
          return
        }
        msgArr.push({
          id: message.msgId,
          lock: true,
          module: messageData.module,
          messageData,
          message,
          roomId: JSON.parse(sessionStorage.getItem("roomConfig") as string).roomId,
        })
        // studentCommandCallback(JSON.parse(sessionStorage.getItem("roomConfig") as string).roomId,message.msgId,message)
      }
      if (userinfo.userType === 1) {
        if (operationObj.module === "whoOperation") {
          httpSend = operationObj.pageModle
          IsReceive = !httpSend
          // 通知权限变化
          notifyPermissionChange()
        }
      } else if (userinfo.userType === 2) {
        if (operationObj.module === "whoOperation") {
          console.log("operation--mqtt收到", operationObj.pageModle)
          //用户能发送，陪练就能接收，陪练一直能发送
          IsReceive = operationObj.pageModle
          httpSend = !IsReceive
          // 通知权限变化
          notifyPermissionChange()
        }
      }
    })
  } catch (error) {
    console.log(error, "Student----mqtt链接错误信息")
  }
}

function InitHttpReceive() {
  if (userinfo.userType === 1) {
    IsReceive = true
    httpSend = false
  }
  if (userinfo.userType === 2) {
    httpSend = true
    IsReceive = false
  }
}

//切换操作
const instructData: any = {
  project: "mqtt",
  page: "mqtt",
  module: "whoOperation",
  pageModle: httpSend,
  userType: 2,
  data: null,
  fn: "",
  param: null,
  timestamp: " ",
}

//切换谁操作
async function whoOperation() {
  if (!IsStartClass) {
    openMsgToast("还未开始上课无法切换")
    return false
  }
  httpSend = !httpSend
  instructData.pageModle = httpSend
  pushMsg(instructData, {
    params: "",
    fn: "",
    msgType: "",
  })
  return true
}

//Student消息任务
async function runTask(): Promise<void> {
  try {
    // 等待任务完成
    await new Promise<void>((resolve, reject) => {
      setTimeout(async () => {
        try {
          const item = msgArr.find((item: any) => item.lock === true)
          if (item) {
            const result = await sendCallback(
              item.roomId,
              item.id,
              item.message,
              item.messageData,
              item
            )
            if (result) {
              // 把item这个数据从msgArr中移除
              msgArr.splice(msgArr.indexOf(item), 1)
            }
          }
          resolve()
        } catch (error) {
          reject(new Error())
        }
      }, 100) // 任务执行延迟
    })

    // 等待间隔后执行下一次
    await new Promise((resolve) => setTimeout(resolve, 100))
    runTask() // 继续下一次执行
  } catch (error) {
    console.error("任务执行出错:", error)
    // 错误处理后继续执行
    setTimeout(runTask, 100) // 出错后等待更长时间再重试
  }
}

//学生网络差的弹窗
async function alert(message: any) {
  const alert = await alertController.create({
    header: "提示",
    message: message,
    backdropDismiss: false, //点击背景不关闭
  })
  await alert.present()
}

//学生发送的时候
async function sendCallback(
  roomId: string,
  msgId: string,
  message: any,
  messageData: any,
  item: any
): Promise<boolean | undefined> {
  try {
    const res = await getCommandCallback({ roomId, msgId })
    if (res === undefined) {
      return undefined
    }
    if (!res.data.data) {
      return res.data.data
    }
    changeUserStatus(message)
    const currentItem = JSON.parse(item.messageData)
    useMsgStore().runMessageHandler(currentItem.module, currentItem)
    return res.data.data
  } catch (error) {
    console.error("Student----Error in sendCallback:", error)
    return undefined
  }
}

// Student订阅mqtt通道--主要用于用户端收到陪练的操作信息
function SubscribeStudent(url: any) {
  let topic = ""
  const qos = 2
  const roomConfig = sessionStorage.getItem("roomConfig") || ""
  if (!roomConfig) return
  if (roomConfig) {
    topic = `${url}${JSON.parse(roomConfig).roomId}`
  }
  try {
    client.subscribe(
      topic,
      {
        qos,
      },
      (error: any, res: any) => {
        if (error) {
          console.log("Student--mqtt-error", error)
          return error
        }
      }
    )
  } catch (e) {
    createConnectionStudent()
  }
}

// Student订阅mqtt通道--主要用于用户端收到陪练的操作信息
function UnSubscribeStudent(url: any) {
  let topic = ""
  const qos = 2
  const roomConfig = sessionStorage.getItem("roomConfig") || ""
  if (!roomConfig) return
  if (roomConfig) {
    topic = `${url}${JSON.parse(roomConfig).roomId}`
  }
  try {
    console.log("Student--订阅开始", "topic")
    client.unsubscribe(topic, { qos }, (error: any, res: any) => {
      if (error) {
        console.log("Student--mqtt-error", error)
        return error
      }
    })
  } catch (e) {
    createConnectionStudent()
  }
}

// 退出房间之后调用断开连接
const destroyConnection = () => {
  if (client.connected) {
    try {
      client.end(false)
    } catch (error: any) {
      console.log(error, "Student----client.end失败------------")
    }
  }
}

// 结构化数据函数，把收到的多个对象合成一个对象的字符串
function instructMeth(instructData: any, obj: any, timestamp: number) {
  return JSON.stringify(
    Object.assign({}, instructData, obj, {
      userType: userinfo.userType,
      ACK: false,
      timestamp,
    })
  )
}

async function pushMsg(instructData: any, obj: any, IsSend = false) {
  const roomConfig = sessionStorage.getItem("roomConfig") || ""

  if (!roomConfig) {
    return Promise.resolve(true)
  }

  if (!JSON.parse(roomConfig).roomId) {
    return Promise.resolve(true)
  }
  console.log("operation--判断是否发送", httpSend, instructData.project)
  // 此函数只处理陪练发送的消息
  // if (userinfo.userType != 2)
  if (!httpSend && instructData.project != "mqtt") {
    return Promise.reject(new Error())
  }

  // 非视频课判断逻辑 0-非视频课 1-视频课
  const appointment = store.getAppointment()
  if (appointment && appointment.videoFlag !== 1) {
    return Promise.resolve(true)
  }

  // const NO_PLAY = sessionStorage.getItem("NO_PLAY") || ""
  // const remoteViewType = sessionStorage.getItem("remoteViewType") || ""
  // if (NO_PLAY === "true" || remoteViewType === "true") {
  //   openMsgToast("对方视频未开启，无法操作")
  //   return Promise.reject(new Error())
  // }

  // 等待500毫秒
  await new Promise((resolve, reject) => {
    setTimeout(
      () => {
        resolve(true)
      },
      instructData.module === "BeforeTest" || instructData.module === "AfterTest" ? 200 : 500
    )
  })
  return new Promise((resolve, reject) => {
    const executeAsync = async () => {
      try {
        let status: any = sessionStorage.getItem("status") || ""
        instructData.componentOptions = JSON.parse(localStorage.getItem("componentOptions") || "{}")
        instructData.pageList = JSON.parse(localStorage.getItem("pageList") || "{}")
        if (status == "") {
          status = sessionStorage.setItem("status", "0")
          httpCount = 0
          alertController.dismiss()
        } else if (status !== "0") {
          if (httpCount >= 5) {
            openMsgToast("操作频繁")
            httpCount = 0
          }
          httpCount++
          status = sessionStorage.setItem("status", "")
          return reject(new Error())
        }
        const res = await handleSenCommandAgain(instructData, obj, resolve, reject, IsSend)
        if (res) {
          return resolve(true)
        } else {
          return reject(new Error())
        }
      } catch (error) {
        return reject(new Error())
      }
    }
    executeAsync()
  })
}

//针对陪练消息是否发送重新组装
let commandList = [] as any

//陪练发送消息的体的组装
async function handleSenCommandAgain(
  instructData: any,
  obj: any,
  resolve: any,
  reject: any,
  isSend: any
) {
  const roomConfig = sessionStorage.getItem("roomConfig") || ""
  const timestamp = new Date().getTime()
  const commandStr = JSON.stringify(instructMeth(instructData, obj, timestamp))
  // commandList.push(commandStr)
  // commandStr=JSON.stringify(commandList);
  teacherParams = {
    command: commandStr,
    roomId: JSON.parse(roomConfig).roomId,
    senderType: 0,
    // instructData: instructData,
    // obj: obj,
    previousTimestamp: previousTimestamp,
    currentTimestamp: timestamp,
    module: instructData.module,
    ack: false,
  }

  try {
    sessionStorage.setItem("status", "1")
    if (!isSend) {
      commandList = []
      const res: any = await sendOperationCommand(teacherParams) // http请求后端操作接口
      if (res.data.code == "200") {
        TeacherCount++
        sessionStorage.setItem("status", "0")
        previousTimestamp = String(timestamp)
        return resolve(true)
      } else {
        if (res.data.code == "430") {
          // openMsgToast("对方网络差，正在同步信息")
          getNotification(JSON.parse(roomConfig).roomId)
          sessionStorage.setItem("status", "1")
          startPolling(roomConfig)
          return reject(new Error())
        }
      }
      return reject(new Error())
    } else {
      return reject(new Error())
    }
  } catch (e) {
    sessionStorage.setItem("status", "")
    return reject(new Error())
  }
}

async function presentAlertSync(message: string) {
  const modal = await modalController.create({
    component: PageDialog,
    id: "PageDialog",
    componentProps: { message },
    backdropDismiss: false,
    cssClass: "center_modal_controller_class3",
  })
  return modal.present()
}

//学生网络恢复的时候把弹窗关闭
function startPolling(roomConfig: any) {
  const timer = setTimeout(() => {
    checkDynamicqueue(JSON.parse(roomConfig).roomId).then((res: any) => {
      if (res.data.data) {
        clearTimeout(timer)
        setTimeout(() => {
          alertController.dismiss()
        }, 1200)
        sessionStorage.setItem("status", "0")
      } else {
        startPolling(roomConfig) // 重新开始轮询
      }
    })
  }, 1000)
}

// 用于组件中注册消息的处理函数
function onMqttMessage(popupId: string, handler: any) {
  useMsgStore().addMessageHandler(popupId, handler)
}

// 用于取消组件中注册的消息处理函数
function offMqttMessage(popupId: string) {
  useMsgStore().removeMessageHandler(popupId)
}

// 定时器，延迟处理指定的秒数
function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

//存储前端页面的操作指令（纯前端指令操作时进行调用）
async function sendOperationCommand(data: any) {
  // 获取服务端时间
  return ajax.post("/av/mqtt/store-operation-command", data, "", "", "", 3000, true)
}

//客户端执行完操作指令后的回调确认接口(学生端收到消息后回执)
async function getCommandCallback(data: any) {
  // 获取服务端时间
  // return new Promise((resolve,reject)=>{
  return ajax.post("/av/mqtt/operation-command-callback", data, "", "", "", 5000, true)
}

//当用户端连接上mqtt后，请求该接口，将用户端的mqtt连接状态存
async function setMqttStatus(roomId: any) {
  return ajax.post(
    "/av/mqtt/store-mqtt-connection-flag?roomId=" + roomId,
    {},
    "",
    "",
    "",
    3000,
    true
  )
}

// 轮询检查用户端的mqtt连接状态
async function checkMqttStatus(roomId: any) {
  return ajax.getAvMqtt("/av/mqtt/check-mqtt-connection?roomId=" + roomId, false)
}

// 403调用指定接口
async function getNotification(roomId: any) {
  // 获取服务端时间
  return ajax.getAvMqtt("/av/mqtt/notification?roomId=" + roomId, false)
}

///重新进入训练室，清除所有指令
// 403调用指定接口
async function clearCommand(roomId: any) {
  IsStartClass = true
  // 获取服务端时间
  return ajax.post(
    "/av/mqtt/clear-operation-command?roomId=" + roomId,
    null,
    "",
    "",
    "",
    3000,
    true
  )
}

//处理异常问题
async function getOperationCommandAfter(roomId: any) {
  // 获取服务端时间
  return ajax.getAvMqtt("/av/mqtt/get-operation-command-after?roomId=" + roomId, false)
}

/// 获取所有指令
async function getOperationCommandBefore(roomId: any) {
  // 获取服务端时间
  return ajax.getAvMqtt("/av/mqtt/get-operation-command-before?roomId=" + roomId, false)
}

///av/mqtt/check-dynamic-queue 轮询执行是否已经满了
async function checkDynamicqueue(roomId: any) {
  // 获取服务端时间
  return ajax.getAvMqtt("/av/mqtt/check-dynamic-queue?roomId=" + roomId, false)
}

//巡查官获取历史数据
function getRoomOperationList(roomId: string) {
  return new Promise((resolve, reject) => {
    ajax
      .getAvMqtt("/av/mqtt/get-all-data?roomId=" + roomId, false)
      .then((res) => {
        const tmpDataList = res.data.data.map((item: any) => {
          item.command = JSON.parse(JSON.parse(item.command))
          return item
        })
        const pageObj = new Map([
          ["Five", "5"],
          ["Nine", "9"],
          ["BeforeTest", "2"],
          ["Sign", "3"],
          ["CutBox", "4"],
          ["Mixture", "6"],
          ["AfterTest", "7"],
          ["Review", "8"],
          ["Paraphrase", "10"],
        ])
        const tmpPageList: Array<any> = []
        const tmpOperateList: Array<any> = []
        tmpDataList.forEach((item: any) => {
          const tmpObj = {
            page: "",
            params: {
              studentId: "",
              step: undefined,
              mastery: undefined,
            },
            msgId: "",
          }
          const pageName = pageObj.get(item.command.module)
          if (pageName) {
            tmpObj.page = pageName
            // tmpObj.params = item.command?.params ?? {}
            tmpObj.msgId = item.msgId
            tmpObj.params.studentId = store.getAppointment()[0]?.studentId ?? ""
            if (item.command.fn === "openCutBoxSync") {
              tmpObj.params.step = item.command?.params?.[0] ?? ""
            }
            tmpPageList.push(tmpObj)
            tmpOperateList.push(item.command)
          }
        })
        const uniquePageList = tmpDataList?.at(-1)?.command?.pageList ?? []
        if (uniquePageList.length > 0) {
          localStorage.setItem("operationList", JSON.stringify(tmpOperateList))
          localStorage.setItem("pageList", JSON.stringify(uniquePageList))
          localStorage.setItem(
            "componentOptions",
            JSON.stringify(tmpDataList.at(-1).command.componentOptions)
          )
          router.push("/modal")
        }
        if (res.data.code == 200) {
          resolve(res.data.data)
          // msgList = [...res.data.data]
        } else {
          reject(res)
        }
      })
      .catch((e) => {
        console.error("1.1--getRoomOperationList", e)
        reject(e)
      })
  })
}

//巡查官针对最后的清晰的消息进行指令执行
async function processMessage(message: any) {
  if (message) {
    pagesQueue.queueOperationPush(message.command)
    useMsgStore().runMessageHandler(message.command.module, message.command)
  }
}

// 获取当前用户是否有发送权限
function getCanSend() {
  return httpSend
}

// 添加权限变化监听器
function addPermissionListener(callback: () => void) {
  permissionListeners.push(callback)
}

// 移除权限变化监听器
function removePermissionListener(callback: () => void) {
  const index = permissionListeners.indexOf(callback)
  if (index > -1) {
    permissionListeners.splice(index, 1)
  }
}

// 通知所有监听器权限已变化
function notifyPermissionChange() {
  permissionListeners.forEach((callback) => callback())
}

export default {
  createConnectionStudent,
  createConnectionAdmin,
  destroyConnection,
  pushMsg,
  onMqttMessage,
  sleep,
  clearCommand,
  setMqttStatus,
  whoOperation,
  InitHttpReceive,
  getCanSend,
  addPermissionListener,
  removePermissionListener,
}
